module.exports = __webpack_public_path__ + "assets/img/limitgene.a8ec65d9.png";